defineDs('DanskeSpil/Domain/Subscriptions/Scripts/Components/Builder/Games/Flow/JackpotSelector',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/Subscriptions/Scripts/Templates/InputRange',
    'DanskeSpil/Domain/Subscriptions/Scripts/Components/Builder/Games/Flow/StepHeader',
  ],
  // eslint-disable-next-line no-unused-vars
  function (m, InputRange, StepHeader) {
    const JackpotSelector = {
      controller: function ({ gameInstance, jackpotOptions, jackpotDefault }) {
        const stepSize = m.prop(1);
        jackpotOptions = jackpotOptions.sort((a, b) => a - b);
        const selectedJackpot = m.prop(gameInstance().plusSubscriptionJackpot() || jackpotDefault || 0);
        gameInstance().plusSubscriptionJackpot(selectedJackpot());

        const onChange = (e) => {
          updateJackpot(jackpotOptions[e - 1]);
        };

        const updateJackpot = (value) => {
          selectedJackpot(value);
          gameInstance().plusSubscriptionJackpot(selectedJackpot());
        };

        return { jackpotOptions, selectedJackpot, updateJackpot, stepSize, onChange };
      },
      view: function (controller, { builderLabelDictionary, gameInstance, jackpotQuickSelectOptions, property, goToNext }) {
        const { jackpotOptions, selectedJackpot, updateJackpot, stepSize, onChange } = controller;
        const inputValue = () => {
          const jackpotValue = selectedJackpot();
          if (jackpotValue < jackpotOptions[0]) {
            return 1;
          }
          if (jackpotValue > jackpotOptions[jackpotOptions.length - 1]) {
            return jackpotOptions.length + 1;
          }
          if (jackpotOptions.includes(jackpotValue)) {
            return jackpotOptions.indexOf(jackpotValue) + 1;
          }

          stepSize('any');
          const closestJackpot = jackpotOptions.reduce((prev, curr) => {
            return (Math.abs(curr - jackpotValue) < Math.abs(prev - jackpotValue) ? curr : prev);
          });

          const closestJackpotIndex = jackpotOptions.indexOf(closestJackpot);
          const otherJackpotIndex = closestJackpotIndex + (closestJackpot > jackpotOptions[closestJackpotIndex + 1] ? 1 : -1);
          const otherJackpot = jackpotOptions[otherJackpotIndex < 0 ? 1 : otherJackpotIndex];
          const ratio = (jackpotValue - Math.min(otherJackpot, closestJackpot)) / (Math.min(otherJackpot, closestJackpot) - Math.max(otherJackpot, closestJackpot));

          return (closestJackpotIndex || 1) + Math.abs(ratio);
        };

        property('builderFlow:nextButton', {
          text: builderLabelDictionary('gameItemFlowJackpotNextButton'),
          disabled: false,
          onClick: () => {
            gameInstance().save();
            goToNext();
          },
        });

        return (
          <div className='max-w-[29.5rem] mx-auto flex flex-col gap-4 px-12 pt-24'>
            <StepHeader heading={builderLabelDictionary('gameItemFlowJackpotHeading')} />
            <div className='py-24 px-16 rounded-16 border-2 border-solid border-yellow-1 flex flex-col gap-12'>
              <div className='text-12 text-center font-extrabold leading-20'>{builderLabelDictionary('gameItemFlowJackpotBoxHeading')}</div>
              <div className='text-28 text-center font-extrabold leading-32'>{ selectedJackpot() } MIO</div>
            </div>
            { jackpotQuickSelectOptions ? <div className='flex gap-12 justify-center pt-6'>
              {jackpotQuickSelectOptions.map((option) => {
                return <div
                  className='cursor-pointer flex-1 text-center text-12 font-bold py-8 px-12 rounded-16 border-1 border-solid border-grey-1'
                  onclick={() => {
                    updateJackpot(option);
                  }}
                >{ option } MIO</div>;
              })}
            </div> : null }
            <InputRange
              controller={controller}
              settings={{
                minValue: 1,
                maxValue: jackpotOptions.length,
                stepValue: 1,
                selectedValue: inputValue(),
                stepSize: stepSize(),
                handler: onChange
              }}
            />
          </div>
        );
      }
    };

    return JackpotSelector;
  });